export function hasRole(user, role) {
  if (!user) {
    return false
  }

  for (let userRole of user.roles) {
    if (userRole === role) {
      return true
    }
  }

  return false
}